<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data.employmentType)">
        <span>{{ organizationTypeString(params.data.employmentType) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererEmploymentType",
    computed: {
        chipColor() {
            return value => {
                if (!value) {
                    return "danger"
                } else if (value === 1) {
                    return "success"
                } else if (value === 2) {
                    return "warning"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (!value) {
                    return this.$t('employeeTypeOptions.unknown')
                } else if (value === 1) {
                    return 'Full-time'
                } else if (value === 2) {
                    return 'Part-time'
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
